
const SET_DYNAMIC_DATA = (state, dynamicData) => {
  state.dynamicData = dynamicData
}

const SET_ISLOADING = (state, isLoading) => {
  state.isLoading = isLoading
}
export default {
  SET_DYNAMIC_DATA,
  SET_ISLOADING
}
